export const PRODUCT_INFORMATION_TAB_NAMES = {
  about: 'Sobre o produto',
  technical: 'Informações Técnicas',
  reviews: 'Avaliações',
} as const

export type ProductInformationTabName =
  typeof PRODUCT_INFORMATION_TAB_NAMES[keyof typeof PRODUCT_INFORMATION_TAB_NAMES]
